/*
**@Author: Aabid 
**@Date: Dec-2025
*/
export const COUNTRY_TIMEZONE = [
  {
    "countryCode": "AF",
    "phoneCode": "+93",
    "countryName": "Afghanistan",
    "flag": "🇦🇫",
    "flagImg": "https://flagcdn.com/af.svg",
    "currency": { "code": "AFN", "name": "Afghan Afghani", "symbol": "؋" },
    "timezones": [
      { "zoneName": "Asia/Kabul", "gmtOffset": "UTC+04:30" }
    ]
  },
  {
    "countryCode": "AL",
    "phoneCode": "+355",
    "countryName": "Albania",
    "flag": "🇦🇱",
    "flagImg": "https://flagcdn.com/al.svg",
    "currency": { "code": "ALL", "name": "Albanian Lek", "symbol": "L" },
    "timezones": [
      { "zoneName": "Europe/Tirane", "gmtOffset": "UTC+01:00" }
    ]
  },
  {
    "countryCode": "DZ",
    "phoneCode": "+213",
    "countryName": "Algeria",
    "flag": "🇩🇿",
    "flagImg": "https://flagcdn.com/dz.svg",
    "currency": { "code": "DZD", "name": "Algerian Dinar", "symbol": "د.ج" },
    "timezones": [
      { "zoneName": "Africa/Algiers", "gmtOffset": "UTC+01:00" }
    ]
  },
  {
    "countryCode": "AD",
    "phoneCode": "+376",
    "countryName": "Andorra",
    "flag": "🇦🇩",
    "flagImg": "https://flagcdn.com/ad.svg",
    "currency": { "code": "EUR", "name": "Euro", "symbol": "€" },
    "timezones": [
      { "zoneName": "Europe/Andorra", "gmtOffset": "UTC+01:00" }
    ]
  },
  {
    "countryCode": "AO",
    "phoneCode": "+244",
    "countryName": "Angola",
    "flag": "🇦🇴",
    "flagImg": "https://flagcdn.com/ao.svg",
    "currency": { "code": "AOA", "name": "Angolan Kwanza", "symbol": "Kz" },
    "timezones": [
      { "zoneName": "Africa/Luanda", "gmtOffset": "UTC+01:00" }
    ]
  },
  {
    "countryCode": "AG",
    "phoneCode": "+1-268",
    "countryName": "Antigua and Barbuda",
    "flag": "🇦🇬",
    "flagImg": "https://flagcdn.com/ag.svg",
    "currency": { "code": "XCD", "name": "East Caribbean Dollar", "symbol": "$" },
    "timezones": [
      { "zoneName": "America/Antigua", "gmtOffset": "UTC-04:00" }
    ]
  },
  {
    "countryCode": "AR",
    "phoneCode": "+54",
    "countryName": "Argentina",
    "flag": "🇦🇷",
    "flagImg": "https://flagcdn.com/ar.svg",
    "currency": { "code": "ARS", "name": "Argentine Peso", "symbol": "$" },
    "timezones": [
      { "zoneName": "America/Argentina/Buenos_Aires", "gmtOffset": "UTC-03:00" },
      { "zoneName": "America/Argentina/Cordoba", "gmtOffset": "UTC-03:00" },
      { "zoneName": "America/Argentina/Salta", "gmtOffset": "UTC-03:00" },
      { "zoneName": "America/Argentina/Jujuy", "gmtOffset": "UTC-03:00" },
      { "zoneName": "America/Argentina/Tucuman", "gmtOffset": "UTC-03:00" },
      { "zoneName": "America/Argentina/Catamarca", "gmtOffset": "UTC-03:00" },
      { "zoneName": "America/Argentina/La_Rioja", "gmtOffset": "UTC-03:00" },
      { "zoneName": "America/Argentina/San_Juan", "gmtOffset": "UTC-03:00" },
      { "zoneName": "America/Argentina/Mendoza", "gmtOffset": "UTC-03:00" },
      { "zoneName": "America/Argentina/San_Luis", "gmtOffset": "UTC-03:00" },
      { "zoneName": "America/Argentina/Rio_Gallegos", "gmtOffset": "UTC-03:00" },
      { "zoneName": "America/Argentina/Ushuaia", "gmtOffset": "UTC-03:00" }
    ]
  },
  {
    "countryCode": "AM",
    "phoneCode": "+374",
    "countryName": "Armenia",
    "flag": "🇦🇲",
    "flagImg": "https://flagcdn.com/am.svg",
    "currency": { "code": "AMD", "name": "Armenian Dram", "symbol": "֏" },
    "timezones": [
      { "zoneName": "Asia/Yerevan", "gmtOffset": "UTC+04:00" }
    ]
  },
  {
    "countryCode": "AU",
    "phoneCode": "+61",
    "countryName": "Australia",
    "flag": "🇦🇺",
    "flagImg": "https://flagcdn.com/au.svg",
    "currency": { "code": "AUD", "name": "Australian Dollar", "symbol": "$" },
    "timezones": [
      { "zoneName": "Australia/Sydney", "gmtOffset": "UTC+10:00" },
      { "zoneName": "Australia/Melbourne", "gmtOffset": "UTC+10:00" },
      { "zoneName": "Australia/Brisbane", "gmtOffset": "UTC+10:00" },
      { "zoneName": "Australia/Adelaide", "gmtOffset": "UTC+09:30" },
      { "zoneName": "Australia/Perth", "gmtOffset": "UTC+08:00" },
      { "zoneName": "Australia/Darwin", "gmtOffset": "UTC+09:30" },
      { "zoneName": "Australia/Hobart", "gmtOffset": "UTC+11:00" }
    ]
  },
  {
    "countryCode": "AT",
    "phoneCode": "+43",
    "countryName": "Austria",
    "flag": "🇦🇹",
    "flagImg": "https://flagcdn.com/at.svg",
    "currency": { "code": "EUR", "name": "Euro", "symbol": "€" },
    "timezones": [
      { "zoneName": "Europe/Vienna", "gmtOffset": "UTC+01:00" }
    ]
  },
  {
    "countryCode": "AZ",
    "phoneCode": "+994",
    "countryName": "Azerbaijan",
    "flag": "🇦🇿",
    "flagImg": "https://flagcdn.com/az.svg",
    "currency": { "code": "AZN", "name": "Azerbaijani Manat", "symbol": "₼" },
    "timezones": [
      { "zoneName": "Asia/Baku", "gmtOffset": "UTC+04:00" }
    ]
  },
  {
    "countryCode": "BS",
    "phoneCode": "+1-242",
    "countryName": "Bahamas",
    "flag": "🇧🇸",
    "flagImg": "https://flagcdn.com/bs.svg",
    "currency": { "code": "BSD", "name": "Bahamian Dollar", "symbol": "$" },
    "timezones": [
      { "zoneName": "America/Nassau", "gmtOffset": "UTC-05:00" }
    ]
  },
  {
    "countryCode": "BH",
    "phoneCode": "+973",
    "countryName": "Bahrain",
    "flag": "🇧🇭",
    "flagImg": "https://flagcdn.com/bh.svg",
    "currency": { "code": "BHD", "name": "Bahraini Dinar", "symbol": ".د.ب" },
    "timezones": [
      { "zoneName": "Asia/Bahrain", "gmtOffset": "UTC+03:00" }
    ]
  },
  {
    "countryCode": "BD",
    "phoneCode": "+880",
    "countryName": "Bangladesh",
    "flag": "🇧🇩",
    "flagImg": "https://flagcdn.com/bd.svg",
    "currency": { "code": "BDT", "name": "Bangladeshi Taka", "symbol": "৳" },
    "timezones": [
      { "zoneName": "Asia/Dhaka", "gmtOffset": "UTC+06:00" }
    ]
  },
  {
    "countryCode": "BB",
    "phoneCode": "+1-246",
    "countryName": "Barbados",
    "flag": "🇧🇧",
    "flagImg": "https://flagcdn.com/bb.svg",
    "currency": { "code": "BBD", "name": "Barbadian Dollar", "symbol": "$" },
    "timezones": [
      { "zoneName": "America/Barbados", "gmtOffset": "UTC-04:00" }
    ]
  },
  {
    "countryCode": "BY",
    "phoneCode": "+375",
    "countryName": "Belarus",
    "flag": "🇧🇾",
    "flagImg": "https://flagcdn.com/by.svg",
    "currency": { "code": "BYN", "name": "Belarusian Ruble", "symbol": "Br" },
    "timezones": [
      { "zoneName": "Europe/Minsk", "gmtOffset": "UTC+03:00" }
    ]
  },
  {
    "countryCode": "BE",
    "phoneCode": "+32",
    "countryName": "Belgium",
    "flag": "🇧🇪",
    "flagImg": "https://flagcdn.com/be.svg",
    "currency": { "code": "EUR", "name": "Euro", "symbol": "€" },
    "timezones": [
      { "zoneName": "Europe/Brussels", "gmtOffset": "UTC+01:00" }
    ]
  },
  {
    "countryCode": "BZ",
    "phoneCode": "+501",
    "countryName": "Belize",
    "flag": "🇧🇿",
    "flagImg": "https://flagcdn.com/bz.svg",
    "currency": { "code": "BZD", "name": "Belize Dollar", "symbol": "$" },
    "timezones": [
      { "zoneName": "America/Belize", "gmtOffset": "UTC-06:00" }
    ]
  },
  {
    "countryCode": "BJ",
    "phoneCode": "+229",
    "countryName": "Benin",
    "flag": "🇧🇯",
    "flagImg": "https://flagcdn.com/bj.svg",
    "currency": { "code": "XOF", "name": "West African CFA Franc", "symbol": "Fr" },
    "timezones": [
      { "zoneName": "Africa/Porto-Novo", "gmtOffset": "UTC+01:00" }
    ]
  },
  {
    "countryCode": "BT",
    "phoneCode": "+975",
    "countryName": "Bhutan",
    "flag": "🇧🇹",
    "flagImg": "https://flagcdn.com/bt.svg",
    "currency": { "code": "BTN", "name": "Bhutanese Ngultrum", "symbol": "Nu." },
    "timezones": [
      { "zoneName": "Asia/Thimphu", "gmtOffset": "UTC+06:00" }
    ]
  },
  {
    "countryCode": "BO",
    "phoneCode": "+591",
    "countryName": "Bolivia",
    "flag": "🇧🇴",
    "flagImg": "https://flagcdn.com/bo.svg",
    "currency": { "code": "BOB", "name": "Bolivian Boliviano", "symbol": "Bs." },
    "timezones": [
      { "zoneName": "America/La_Paz", "gmtOffset": "UTC-04:00" }
    ]
  },
  {
    "countryCode": "BA",
    "phoneCode": "+387",
    "countryName": "Bosnia and Herzegovina",
    "flag": "🇧🇦",
    "flagImg": "https://flagcdn.com/ba.svg",
    "currency": { "code": "BAM", "name": "Bosnia-Herzegovina Convertible Mark", "symbol": "KM" },
    "timezones": [
      { "zoneName": "Europe/Sarajevo", "gmtOffset": "UTC+01:00" }
    ]
  },
  {
    "countryCode": "BW",
    "phoneCode": "+267",
    "countryName": "Botswana",
    "flag": "🇧🇼",
    "flagImg": "https://flagcdn.com/bw.svg",
    "currency": { "code": "BWP", "name": "Botswana Pula", "symbol": "P" },
    "timezones": [
      { "zoneName": "Africa/Gaborone", "gmtOffset": "UTC+02:00" }
    ]
  },
  {
    "countryCode": "BR",
    "phoneCode": "+55",
    "countryName": "Brazil",
    "flag": "🇧🇷",
    "flagImg": "https://flagcdn.com/br.svg",
    "currency": { "code": "BRL", "name": "Brazilian Real", "symbol": "R$" },
    "timezones": [
      { "zoneName": "America/Sao_Paulo", "gmtOffset": "UTC-03:00" },
      { "zoneName": "America/Manaus", "gmtOffset": "UTC-04:00" },
      { "zoneName": "America/Belem", "gmtOffset": "UTC-03:00" },
      { "zoneName": "America/Fortaleza", "gmtOffset": "UTC-03:00" },
      { "zoneName": "America/Recife", "gmtOffset": "UTC-03:00" },
      { "zoneName": "America/Araguaina", "gmtOffset": "UTC-03:00" },
      { "zoneName": "America/Maceio", "gmtOffset": "UTC-03:00" },
      { "zoneName": "America/Bahia", "gmtOffset": "UTC-03:00" },
      { "zoneName": "America/Cuiaba", "gmtOffset": "UTC-04:00" },
      { "zoneName": "America/Porto_Velho", "gmtOffset": "UTC-04:00" },
      { "zoneName": "America/Boa_Vista", "gmtOffset": "UTC-04:00" },
      { "zoneName": "America/Campo_Grande", "gmtOffset": "UTC-04:00" },
      { "zoneName": "America/Rio_Branco", "gmtOffset": "UTC-05:00" },
      { "zoneName": "America/Noronha", "gmtOffset": "UTC-02:00" }
    ]
  },
  {
    "countryCode": "BN",
    "phoneCode": "+673",
    "countryName": "Brunei",
    "flag": "🇧🇳",
    "flagImg": "https://flagcdn.com/bn.svg",
    "currency": { "code": "BND", "name": "Brunei Dollar", "symbol": "$" },
    "timezones": [
      { "zoneName": "Asia/Brunei", "gmtOffset": "UTC+08:00" }
    ]
  },
  {
    "countryCode": "BG",
    "phoneCode": "+359",
    "countryName": "Bulgaria",
    "flag": "🇧🇬",
    "flagImg": "https://flagcdn.com/bg.svg",
    "currency": { "code": "BGN", "name": "Bulgarian Lev", "symbol": "лв" },
    "timezones": [
      { "zoneName": "Europe/Sofia", "gmtOffset": "UTC+02:00" }
    ]
  },
  {
    "countryCode": "BF",
    "phoneCode": "+226",
    "countryName": "Burkina Faso",
    "flag": "🇧🇫",
    "flagImg": "https://flagcdn.com/bf.svg",
    "currency": { "code": "XOF", "name": "West African CFA Franc", "symbol": "Fr" },
    "timezones": [
      { "zoneName": "Africa/Ouagadougou", "gmtOffset": "UTC+00:00" }
    ]
  },
  {
    "countryCode": "BI",
    "phoneCode": "+257",
    "countryName": "Burundi",
    "flag": "🇧🇮",
    "flagImg": "https://flagcdn.com/bi.svg",
    "currency": { "code": "BIF", "name": "Burundian Franc", "symbol": "Fr" },
    "timezones": [
      { "zoneName": "Africa/Bujumbura", "gmtOffset": "UTC+02:00" }
    ]
  },
  {
    "countryCode": "KH",
    "phoneCode": "+855",
    "countryName": "Cambodia",
    "flag": "🇰🇭",
    "flagImg": "https://flagcdn.com/kh.svg",
    "currency": { "code": "KHR", "name": "Cambodian Riel", "symbol": "៛" },
    "timezones": [
      { "zoneName": "Asia/Phnom_Penh", "gmtOffset": "UTC+07:00" }
    ]
  },
  {
    "countryCode": "CM",
    "phoneCode": "+237",
    "countryName": "Cameroon",
    "flag": "🇨🇲",
    "flagImg": "https://flagcdn.com/cm.svg",
    "currency": { "code": "XAF", "name": "Central African CFA Franc", "symbol": "Fr" },
    "timezones": [
      { "zoneName": "Africa/Douala", "gmtOffset": "UTC+01:00" }
    ]
  },
  {
    "countryCode": "CA",
    "phoneCode": "+1",
    "countryName": "Canada",
    "flag": "🇨🇦",
    "flagImg": "https://flagcdn.com/ca.svg",
    "currency": { "code": "CAD", "name": "Canadian Dollar", "symbol": "$" },
    "timezones": [
      { "zoneName": "America/Toronto", "gmtOffset": "UTC-05:00" },
      { "zoneName": "America/Vancouver", "gmtOffset": "UTC-08:00" },
      { "zoneName": "America/Edmonton", "gmtOffset": "UTC-07:00" },
      { "zoneName": "America/Winnipeg", "gmtOffset": "UTC-06:00" },
      { "zoneName": "America/Halifax", "gmtOffset": "UTC-04:00" },
      { "zoneName": "America/St_Johns", "gmtOffset": "UTC-03:30" }
    ]
  },
  {
    "countryCode": "CV",
    "phoneCode": "+238",
    "countryName": "Cape Verde",
    "flag": "🇨🇻",
    "flagImg": "https://flagcdn.com/cv.svg",
    "currency": { "code": "CVE", "name": "Cape Verdean Escudo", "symbol": "Esc" },
    "timezones": [
      { "zoneName": "Atlantic/Cape_Verde", "gmtOffset": "UTC-01:00" }
    ]
  },
  {
    "countryCode": "CF",
    "phoneCode": "+236",
    "countryName": "Central African Republic",
    "flag": "🇨🇫",
    "flagImg": "https://flagcdn.com/cf.svg",
    "currency": { "code": "XAF", "name": "Central African CFA Franc", "symbol": "Fr" },
    "timezones": [
      { "zoneName": "Africa/Bangui", "gmtOffset": "UTC+01:00" }
    ]
  },
  {
    "countryCode": "TD",
    "phoneCode": "+235",
    "countryName": "Chad",
    "flag": "🇹🇩",
    "flagImg": "https://flagcdn.com/td.svg",
    "currency": { "code": "XAF", "name": "Central African CFA Franc", "symbol": "Fr" },
    "timezones": [
      { "zoneName": "Africa/Ndjamena", "gmtOffset": "UTC+01:00" }
    ]
  },
  {
    "countryCode": "CL",
    "phoneCode": "+56",
    "countryName": "Chile",
    "flag": "🇨🇱",
    "flagImg": "https://flagcdn.com/cl.svg",
    "currency": { "code": "CLP", "name": "Chilean Peso", "symbol": "$" },
    "timezones": [
      { "zoneName": "America/Santiago", "gmtOffset": "UTC-04:00" },
      { "zoneName": "Pacific/Easter", "gmtOffset": "UTC-06:00" }
    ]
  },
  {
    "countryCode": "CN",
    "phoneCode": "+86",
    "countryName": "China",
    "flag": "🇨🇳",
    "flagImg": "https://flagcdn.com/cn.svg",
    "currency": { "code": "CNY", "name": "Chinese Yuan", "symbol": "¥" },
    "timezones": [
      { "zoneName": "Asia/Shanghai", "gmtOffset": "UTC+08:00" },
      { "zoneName": "Asia/Urumqi", "gmtOffset": "UTC+06:00" }
    ]
  },
  {
    "countryCode": "CO",
    "phoneCode": "+57",
    "countryName": "Colombia",
    "flag": "🇨🇴",
    "flagImg": "https://flagcdn.com/co.svg",
    "currency": { "code": "COP", "name": "Colombian Peso", "symbol": "$" },
    "timezones": [
      { "zoneName": "America/Bogota", "gmtOffset": "UTC-05:00" }
    ]
  },
  {
    "countryCode": "KM",
    "phoneCode": "+269",
    "countryName": "Comoros",
    "flag": "🇰🇲",
    "flagImg": "https://flagcdn.com/km.svg",
    "currency": { "code": "KMF", "name": "Comorian Franc", "symbol": "Fr" },
    "timezones": [
      { "zoneName": "Indian/Comoro", "gmtOffset": "UTC+03:00" }
    ]
  },
  {
    "countryCode": "CG",
    "phoneCode": "+242",
    "countryName": "Congo",
    "flag": "🇨🇬",
    "flagImg": "https://flagcdn.com/cg.svg",
    "currency": { "code": "XAF", "name": "Central African CFA Franc", "symbol": "Fr" },
    "timezones": [
      { "zoneName": "Africa/Brazzaville", "gmtOffset": "UTC+01:00" }
    ]
  },
  {
    "countryCode": "CD",
    "phoneCode": "+243",
    "countryName": "Congo, Democratic Republic of the",
    "flag": "🇨🇩",
    "flagImg": "https://flagcdn.com/cd.svg",
    "currency": { "code": "CDF", "name": "Congolese Franc", "symbol": "Fr" },
    "timezones": [
      { "zoneName": "Africa/Kinshasa", "gmtOffset": "UTC+01:00" },
      { "zoneName": "Africa/Lubumbashi", "gmtOffset": "UTC+02:00" }
    ]
  },
  {
    "countryCode": "CR",
    "phoneCode": "+506",
    "countryName": "Costa Rica",
    "flag": "🇨🇷",
    "flagImg": "https://flagcdn.com/cr.svg",
    "currency": { "code": "CRC", "name": "Costa Rican Colón", "symbol": "₡" },
    "timezones": [
      { "zoneName": "America/Costa_Rica", "gmtOffset": "UTC-06:00" }
    ]
  },
  {
    "countryCode": "HR",
    "phoneCode": "+385",
    "countryName": "Croatia",
    "flag": "🇭🇷",
    "flagImg": "https://flagcdn.com/hr.svg",
    "currency": { "code": "EUR", "name": "Euro", "symbol": "€" },
    "timezones": [
      { "zoneName": "Europe/Zagreb", "gmtOffset": "UTC+01:00" }
    ]
  },
  {
    "countryCode": "CU",
    "phoneCode": "+53",
    "countryName": "Cuba",
    "flag": "🇨🇺",
    "flagImg": "https://flagcdn.com/cu.svg",
    "currency": { "code": "CUP", "name": "Cuban Peso", "symbol": "$" },
    "timezones": [
      { "zoneName": "America/Havana", "gmtOffset": "UTC-05:00" }
    ]
  },
  {
    "countryCode": "CY",
    "phoneCode": "+357",
    "countryName": "Cyprus",
    "flag": "🇨🇾",
    "flagImg": "https://flagcdn.com/cy.svg",
    "currency": { "code": "EUR", "name": "Euro", "symbol": "€" },
    "timezones": [
      { "zoneName": "Asia/Nicosia", "gmtOffset": "UTC+02:00" }
    ]
  },
  {
    "countryCode": "CZ",
    "phoneCode": "+420",
    "countryName": "Czech Republic",
    "flag": "🇨🇿",
    "flagImg": "https://flagcdn.com/cz.svg",
    "currency": { "code": "CZK", "name": "Czech Koruna", "symbol": "Kč" },
    "timezones": [
      { "zoneName": "Europe/Prague", "gmtOffset": "UTC+01:00" }
    ]
  },
  {
    "countryCode": "DK",
    "phoneCode": "+45",
    "countryName": "Denmark",
    "flag": "🇩🇰",
    "flagImg": "https://flagcdn.com/dk.svg",
    "currency": { "code": "DKK", "name": "Danish Krone", "symbol": "kr" },
    "timezones": [
      { "zoneName": "Europe/Copenhagen", "gmtOffset": "UTC+01:00" }
    ]
  },
  {
    "countryCode": "DJ",
    "phoneCode": "+253",
    "countryName": "Djibouti",
    "flag": "🇩🇯",
    "flagImg": "https://flagcdn.com/dj.svg",
    "currency": { "code": "DJF", "name": "Djiboutian Franc", "symbol": "Fr" },
    "timezones": [
      { "zoneName": "Africa/Djibouti", "gmtOffset": "UTC+03:00" }
    ]
  },
  {
    "countryCode": "DM",
    "phoneCode": "+1-767",
    "countryName": "Dominica",
    "flag": "🇩🇲",
    "flagImg": "https://flagcdn.com/dm.svg",
    "currency": { "code": "XCD", "name": "East Caribbean Dollar", "symbol": "$" },
    "timezones": [
      { "zoneName": "America/Dominica", "gmtOffset": "UTC-04:00" }
    ]
  },
  {
    "countryCode": "DO",
    "phoneCode": "+1-809",
    "countryName": "Dominican Republic",
    "flag": "🇩🇴",
    "flagImg": "https://flagcdn.com/do.svg",
    "currency": { "code": "DOP", "name": "Dominican Peso", "symbol": "$" },
    "timezones": [
      { "zoneName": "America/Santo_Domingo", "gmtOffset": "UTC-04:00" }
    ]
  },
  {
    "countryCode": "EC",
    "phoneCode": "+593",
    "countryName": "Ecuador",
    "flag": "🇪🇨",
    "flagImg": "https://flagcdn.com/ec.svg",
    "currency": { "code": "USD", "name": "United States Dollar", "symbol": "$" },
    "timezones": [
      { "zoneName": "America/Guayaquil", "gmtOffset": "UTC-05:00" },
      { "zoneName": "Pacific/Galapagos", "gmtOffset": "UTC-06:00" }
    ]
  },
  {
    "countryCode": "EG",
    "phoneCode": "+20",
    "countryName": "Egypt",
    "flag": "🇪🇬",
    "flagImg": "https://flagcdn.com/eg.svg",
    "currency": { "code": "EGP", "name": "Egyptian Pound", "symbol": "£" },
    "timezones": [
      { "zoneName": "Africa/Cairo", "gmtOffset": "UTC+02:00" }
    ]
  },
  {
    "countryCode": "SV",
    "phoneCode": "+503",
    "countryName": "El Salvador",
    "flag": "🇸🇻",
    "flagImg": "https://flagcdn.com/sv.svg",
    "currency": { "code": "USD", "name": "United States Dollar", "symbol": "$" },
    "timezones": [
      { "zoneName": "America/El_Salvador", "gmtOffset": "UTC-06:00" }
    ]
  },
  {
    "countryCode": "GQ",
    "phoneCode": "+240",
    "countryName": "Equatorial Guinea",
    "flag": "🇬🇶",
    "flagImg": "https://flagcdn.com/gq.svg",
    "currency": { "code": "XAF", "name": "Central African CFA Franc", "symbol": "Fr" },
    "timezones": [
      { "zoneName": "Africa/Malabo", "gmtOffset": "UTC+01:00" }
    ]
  },
  {
    "countryCode": "ER",
    "phoneCode": "+291",
    "countryName": "Eritrea",
    "flag": "🇪🇷",
    "flagImg": "https://flagcdn.com/er.svg",
    "currency": { "code": "ERN", "name": "Eritrean Nakfa", "symbol": "Nfk" },
    "timezones": [
      { "zoneName": "Africa/Asmara", "gmtOffset": "UTC+03:00" }
    ]
  },
  {
    "countryCode": "EE",
    "phoneCode": "+372",
    "countryName": "Estonia",
    "flag": "🇪🇪",
    "flagImg": "https://flagcdn.com/ee.svg",
    "currency": { "code": "EUR", "name": "Euro", "symbol": "€" },
    "timezones": [
      { "zoneName": "Europe/Tallinn", "gmtOffset": "UTC+02:00" }
    ]
  },
  {
    "countryCode": "SZ",
    "phoneCode": "+268",
    "countryName": "Eswatini",
    "flag": "🇸🇿",
    "flagImg": "https://flagcdn.com/sz.svg",
    "currency": { "code": "SZL", "name": "Swazi Lilangeni", "symbol": "L" },
    "timezones": [
      { "zoneName": "Africa/Mbabane", "gmtOffset": "UTC+02:00" }
    ]
  },
  {
    "countryCode": "ET",
    "phoneCode": "+251",
    "countryName": "Ethiopia",
    "flag": "🇪🇹",
    "flagImg": "https://flagcdn.com/et.svg",
    "currency": { "code": "ETB", "name": "Ethiopian Birr", "symbol": "Br" },
    "timezones": [
      { "zoneName": "Africa/Addis_Ababa", "gmtOffset": "UTC+03:00" }
    ]
  },
  {
    "countryCode": "FJ",
    "phoneCode": "+679",
    "countryName": "Fiji",
    "flag": "🇫🇯",
    "flagImg": "https://flagcdn.com/fj.svg",
    "currency": { "code": "FJD", "name": "Fijian Dollar", "symbol": "$" },
    "timezones": [
      { "zoneName": "Pacific/Fiji", "gmtOffset": "UTC+12:00" }
    ]
  },
  {
    "countryCode": "FI",
    "phoneCode": "+358",
    "countryName": "Finland",
    "flag": "🇫🇮",
    "flagImg": "https://flagcdn.com/fi.svg",
    "currency": { "code": "EUR", "name": "Euro", "symbol": "€" },
    "timezones": [
      { "zoneName": "Europe/Helsinki", "gmtOffset": "UTC+02:00" }
    ]
  },
  {
    "countryCode": "FR",
    "phoneCode": "+33",
    "countryName": "France",
    "flag": "🇫🇷",
    "flagImg": "https://flagcdn.com/fr.svg",
    "currency": { "code": "EUR", "name": "Euro", "symbol": "€" },
    "timezones": [
      { "zoneName": "Europe/Paris", "gmtOffset": "UTC+01:00" }
    ]
  },
  {
    "countryCode": "GA",
    "phoneCode": "+241",
    "countryName": "Gabon",
    "flag": "🇬🇦",
    "flagImg": "https://flagcdn.com/ga.svg",
    "currency": { "code": "XAF", "name": "Central African CFA Franc", "symbol": "Fr" },
    "timezones": [
      { "zoneName": "Africa/Libreville", "gmtOffset": "UTC+01:00" }
    ]
  },
  {
    "countryCode": "GM",
    "phoneCode": "+220",
    "countryName": "Gambia",
    "flag": "🇬🇲",
    "flagImg": "https://flagcdn.com/gm.svg",
    "currency": { "code": "GMD", "name": "Gambian Dalasi", "symbol": "D" },
    "timezones": [
      { "zoneName": "Africa/Banjul", "gmtOffset": "UTC+00:00" }
    ]
  },
  {
    "countryCode": "GE",
    "phoneCode": "+995",
    "countryName": "Georgia",
    "flag": "🇬🇪",
    "flagImg": "https://flagcdn.com/ge.svg",
    "currency": { "code": "GEL", "name": "Georgian Lari", "symbol": "₾" },
    "timezones": [
      { "zoneName": "Asia/Tbilisi", "gmtOffset": "UTC+04:00" }
    ]
  },
  {
    "countryCode": "DE",
    "phoneCode": "+49",
    "countryName": "Germany",
    "flag": "🇩🇪",
    "flagImg": "https://flagcdn.com/de.svg",
    "currency": { "code": "EUR", "name": "Euro", "symbol": "€" },
    "timezones": [
      { "zoneName": "Europe/Berlin", "gmtOffset": "UTC+01:00" }
    ]
  },
  {
    "countryCode": "GH",
    "phoneCode": "+233",
    "countryName": "Ghana",
    "flag": "🇬🇭",
    "flagImg": "https://flagcdn.com/gh.svg",
    "currency": { "code": "GHS", "name": "Ghanaian Cedi", "symbol": "₵" },
    "timezones": [
      { "zoneName": "Africa/Accra", "gmtOffset": "UTC+00:00" }
    ]
  },
  {
    "countryCode": "GR",
    "phoneCode": "+30",
    "countryName": "Greece",
    "flag": "🇬🇷",
    "flagImg": "https://flagcdn.com/gr.svg",
    "currency": { "code": "EUR", "name": "Euro", "symbol": "€" },
    "timezones": [
      { "zoneName": "Europe/Athens", "gmtOffset": "UTC+02:00" }
    ]
  },
  {
    "countryCode": "GD",
    "phoneCode": "+1-473",
    "countryName": "Grenada",
    "flag": "🇬🇩",
    "flagImg": "https://flagcdn.com/gd.svg",
    "currency": { "code": "XCD", "name": "East Caribbean Dollar", "symbol": "$" },
    "timezones": [
      { "zoneName": "America/Grenada", "gmtOffset": "UTC-04:00" }
    ]
  },
  {
    "countryCode": "GT",
    "phoneCode": "+502",
    "countryName": "Guatemala",
    "flag": "🇬🇹",
    "flagImg": "https://flagcdn.com/gt.svg",
    "currency": { "code": "GTQ", "name": "Guatemalan Quetzal", "symbol": "Q" },
    "timezones": [
      { "zoneName": "America/Guatemala", "gmtOffset": "UTC-06:00" }
    ]
  },
  {
    "countryCode": "GN",
    "phoneCode": "+224",
    "countryName": "Guinea",
    "flag": "🇬🇳",
    "flagImg": "https://flagcdn.com/gn.svg",
    "currency": { "code": "GNF", "name": "Guinean Franc", "symbol": "Fr" },
    "timezones": [
      { "zoneName": "Africa/Conakry", "gmtOffset": "UTC+00:00" }
    ]
  },
  {
    "countryCode": "GW",
    "phoneCode": "+245",
    "countryName": "Guinea-Bissau",
    "flag": "🇬🇼",
    "flagImg": "https://flagcdn.com/gw.svg",
    "currency": { "code": "XOF", "name": "West African CFA Franc", "symbol": "Fr" },
    "timezones": [
      { "zoneName": "Africa/Bissau", "gmtOffset": "UTC+00:00" }
    ]
  },
  {
    "countryCode": "GY",
    "phoneCode": "+592",
    "countryName": "Guyana",
    "flag": "🇬🇾",
    "flagImg": "https://flagcdn.com/gy.svg",
    "currency": { "code": "GYD", "name": "Guyanese Dollar", "symbol": "$" },
    "timezones": [
      { "zoneName": "America/Guyana", "gmtOffset": "UTC-04:00" }
    ]
  },
  {
    "countryCode": "HT",
    "phoneCode": "+509",
    "countryName": "Haiti",
    "flag": "🇭🇹",
    "flagImg": "https://flagcdn.com/ht.svg",
    "currency": { "code": "HTG", "name": "Haitian Gourde", "symbol": "G" },
    "timezones": [
      { "zoneName": "America/Port-au-Prince", "gmtOffset": "UTC-05:00" }
    ]
  },
  {
    "countryCode": "HN",
    "phoneCode": "+504",
    "countryName": "Honduras",
    "flag": "🇭🇳",
    "flagImg": "https://flagcdn.com/hn.svg",
    "currency": { "code": "HNL", "name": "Honduran Lempira", "symbol": "L" },
    "timezones": [
      { "zoneName": "America/Tegucigalpa", "gmtOffset": "UTC-06:00" }
    ]
  },
  {
    "countryCode": "HK",
    "phoneCode": "+852",
    "countryName": "Hong Kong",
    "flag": "🇭🇰",
    "flagImg": "https://flagcdn.com/hk.svg",
    "currency": { "code": "HKD", "name": "Hong Kong Dollar", "symbol": "$" },
    "timezones": [
      { "zoneName": "Asia/Hong_Kong", "gmtOffset": "UTC+08:00" }
    ]
  },
  {
    "countryCode": "HU",
    "phoneCode": "+36",
    "countryName": "Hungary",
    "flag": "🇭🇺",
    "flagImg": "https://flagcdn.com/hu.svg",
    "currency": { "code": "HUF", "name": "Hungarian Forint", "symbol": "Ft" },
    "timezones": [
      { "zoneName": "Europe/Budapest", "gmtOffset": "UTC+01:00" }
    ]
  },
  {
    "countryCode": "IS",
    "phoneCode": "+354",
    "countryName": "Iceland",
    "flag": "🇮🇸",
    "flagImg": "https://flagcdn.com/is.svg",
    "currency": { "code": "ISK", "name": "Icelandic Króna", "symbol": "kr" },
    "timezones": [
      { "zoneName": "Atlantic/Reykjavik", "gmtOffset": "UTC+00:00" }
    ]
  },
  {
    "countryCode": "IN",
    "phoneCode": "+91",
    "countryName": "India",
    "flag": "🇮🇳",
    "flagImg": "https://flagcdn.com/in.svg",
    "currency": { "code": "INR", "name": "Indian Rupee", "symbol": "₹" },
    "timezones": [
      { "zoneName": "Asia/Kolkata", "gmtOffset": "UTC+05:30" }
    ]
  },
  {
    "countryCode": "ID",
    "phoneCode": "+62",
    "countryName": "Indonesia",
    "flag": "🇮🇩",
    "flagImg": "https://flagcdn.com/id.svg",
    "currency": { "code": "IDR", "name": "Indonesian Rupiah", "symbol": "Rp" },
    "timezones": [
      { "zoneName": "Asia/Jakarta", "gmtOffset": "UTC+07:00" },
      { "zoneName": "Asia/Makassar", "gmtOffset": "UTC+08:00" },
      { "zoneName": "Asia/Jayapura", "gmtOffset": "UTC+09:00" }
    ]
  },
  {
    "countryCode": "IR",
    "phoneCode": "+98",
    "countryName": "Iran",
    "flag": "🇮🇷",
    "flagImg": "https://flagcdn.com/ir.svg",
    "currency": { "code": "IRR", "name": "Iranian Rial", "symbol": "﷼" },
    "timezones": [
      { "zoneName": "Asia/Tehran", "gmtOffset": "UTC+03:30" }
    ]
  },
  {
    "countryCode": "IQ",
    "phoneCode": "+964",
    "countryName": "Iraq",
    "flag": "🇮🇶",
    "flagImg": "https://flagcdn.com/iq.svg",
    "currency": { "code": "IQD", "name": "Iraqi Dinar", "symbol": "ع.د" },
    "timezones": [
      { "zoneName": "Asia/Baghdad", "gmtOffset": "UTC+03:00" }
    ]
  },
  {
    "countryCode": "IE",
    "phoneCode": "+353",
    "countryName": "Ireland",
    "flag": "🇮🇪",
    "flagImg": "https://flagcdn.com/ie.svg",
    "currency": { "code": "EUR", "name": "Euro", "symbol": "€" },
    "timezones": [
      { "zoneName": "Europe/Dublin", "gmtOffset": "UTC+00:00" }
    ]
  },
  {
    "countryCode": "IL",
    "phoneCode": "+972",
    "countryName": "Israel",
    "flag": "🇮🇱",
    "flagImg": "https://flagcdn.com/il.svg",
    "currency": { "code": "ILS", "name": "Israeli New Shekel", "symbol": "₪" },
    "timezones": [
      { "zoneName": "Asia/Jerusalem", "gmtOffset": "UTC+02:00" }
    ]
  },
  {
    "countryCode": "IT",
    "phoneCode": "+39",
    "countryName": "Italy",
    "flag": "🇮🇹",
    "flagImg": "https://flagcdn.com/it.svg",
    "currency": { "code": "EUR", "name": "Euro", "symbol": "€" },
    "timezones": [
      { "zoneName": "Europe/Rome", "gmtOffset": "UTC+01:00" }
    ]
  },
  {
    "countryCode": "JM",
    "phoneCode": "+1-876",
    "countryName": "Jamaica",
    "flag": "🇯🇲",
    "flagImg": "https://flagcdn.com/jm.svg",
    "currency": { "code": "JMD", "name": "Jamaican Dollar", "symbol": "$" },
    "timezones": [
      { "zoneName": "America/Jamaica", "gmtOffset": "UTC-05:00" }
    ]
  },
  {
    "countryCode": "JP",
    "phoneCode": "+81",
    "countryName": "Japan",
    "flag": "🇯🇵",
    "flagImg": "https://flagcdn.com/jp.svg",
    "currency": { "code": "JPY", "name": "Japanese Yen", "symbol": "¥" },
    "timezones": [
      { "zoneName": "Asia/Tokyo", "gmtOffset": "UTC+09:00" }
    ]
  },
  {
    "countryCode": "JO",
    "phoneCode": "+962",
    "countryName": "Jordan",
    "flag": "🇯🇴",
    "flagImg": "https://flagcdn.com/jo.svg",
    "currency": { "code": "JOD", "name": "Jordanian Dinar", "symbol": "د.ا" },
    "timezones": [
      { "zoneName": "Asia/Amman", "gmtOffset": "UTC+03:00" }
    ]
  },
  {
    "countryCode": "KZ",
    "phoneCode": "+7",
    "countryName": "Kazakhstan",
    "flag": "🇰🇿",
    "flagImg": "https://flagcdn.com/kz.svg",
    "currency": { "code": "KZT", "name": "Kazakhstani Tenge", "symbol": "₸" },
    "timezones": [
      { "zoneName": "Asia/Almaty", "gmtOffset": "UTC+05:00" },
      { "zoneName": "Asia/Qyzylorda", "gmtOffset": "UTC+05:00" },
      { "zoneName": "Asia/Aqtobe", "gmtOffset": "UTC+05:00" },
      { "zoneName": "Asia/Aqtau", "gmtOffset": "UTC+05:00" },
      { "zoneName": "Asia/Oral", "gmtOffset": "UTC+05:00" }
    ]
  },
  {
    "countryCode": "KE",
    "phoneCode": "+254",
    "countryName": "Kenya",
    "flag": "🇰🇪",
    "flagImg": "https://flagcdn.com/ke.svg",
    "currency": { "code": "KES", "name": "Kenyan Shilling", "symbol": "KSh" },
    "timezones": [
      { "zoneName": "Africa/Nairobi", "gmtOffset": "UTC+03:00" }
    ]
  },
  {
    "countryCode": "KI",
    "phoneCode": "+686",
    "countryName": "Kiribati",
    "flag": "🇰🇮",
    "flagImg": "https://flagcdn.com/ki.svg",
    "currency": { "code": "AUD", "name": "Australian Dollar", "symbol": "$" },
    "timezones": [
      { "zoneName": "Pacific/Tarawa", "gmtOffset": "UTC+12:00" },
      { "zoneName": "Pacific/Enderbury", "gmtOffset": "UTC+13:00" },
      { "zoneName": "Pacific/Kiritimati", "gmtOffset": "UTC+14:00" }
    ]
  },
  {
    "countryCode": "KP",
    "phoneCode": "+850",
    "countryName": "Korea, North",
    "flag": "🇰🇵",
    "flagImg": "https://flagcdn.com/kp.svg",
    "currency": { "code": "KPW", "name": "North Korean Won", "symbol": "₩" },
    "timezones": [
      { "zoneName": "Asia/Pyongyang", "gmtOffset": "UTC+09:00" }
    ]
  },
  {
    "countryCode": "KR",
    "phoneCode": "+82",
    "countryName": "Korea, South",
    "flag": "🇰🇷",
    "flagImg": "https://flagcdn.com/kr.svg",
    "currency": { "code": "KRW", "name": "South Korean Won", "symbol": "₩" },
    "timezones": [
      { "zoneName": "Asia/Seoul", "gmtOffset": "UTC+09:00" }
    ]
  },
  {
    "countryCode": "KW",
    "phoneCode": "+965",
    "countryName": "Kuwait",
    "flag": "🇰🇼",
    "flagImg": "https://flagcdn.com/kw.svg",
    "currency": { "code": "KWD", "name": "Kuwaiti Dinar", "symbol": "د.ك" },
    "timezones": [
      { "zoneName": "Asia/Kuwait", "gmtOffset": "UTC+03:00" }
    ]
  },
  {
    "countryCode": "KG",
    "phoneCode": "+996",
    "countryName": "Kyrgyzstan",
    "flag": "🇰🇬",
    "flagImg": "https://flagcdn.com/kg.svg",
    "currency": { "code": "KGS", "name": "Kyrgyzstani Som", "symbol": "с" },
    "timezones": [
      { "zoneName": "Asia/Bishkek", "gmtOffset": "UTC+06:00" }
    ]
  },
  {
    "countryCode": "LA",
    "phoneCode": "+856",
    "countryName": "Laos",
    "flag": "🇱🇦",
    "flagImg": "https://flagcdn.com/la.svg",
    "currency": { "code": "LAK", "name": "Lao Kip", "symbol": "₭" },
    "timezones": [
      { "zoneName": "Asia/Vientiane", "gmtOffset": "UTC+07:00" }
    ]
  },
  {
    "countryCode": "LV",
    "phoneCode": "+371",
    "countryName": "Latvia",
    "flag": "🇱🇻",
    "flagImg": "https://flagcdn.com/lv.svg",
    "currency": { "code": "EUR", "name": "Euro", "symbol": "€" },
    "timezones": [
      { "zoneName": "Europe/Riga", "gmtOffset": "UTC+02:00" }
    ]
  },
  {
    "countryCode": "LB",
    "phoneCode": "+961",
    "countryName": "Lebanon",
    "flag": "🇱🇧",
    "flagImg": "https://flagcdn.com/lb.svg",
    "currency": { "code": "LBP", "name": "Lebanese Pound", "symbol": "ل.ل" },
    "timezones": [
      { "zoneName": "Asia/Beirut", "gmtOffset": "UTC+02:00" }
    ]
  },
  {
    "countryCode": "LS",
    "phoneCode": "+266",
    "countryName": "Lesotho",
    "flag": "🇱🇸",
    "flagImg": "https://flagcdn.com/ls.svg",
    "currency": { "code": "LSL", "name": "Lesotho Loti", "symbol": "L" },
    "timezones": [
      { "zoneName": "Africa/Maseru", "gmtOffset": "UTC+02:00" }
    ]
  },
  {
    "countryCode": "LR",
    "phoneCode": "+231",
    "countryName": "Liberia",
    "flag": "🇱🇷",
    "flagImg": "https://flagcdn.com/lr.svg",
    "currency": { "code": "LRD", "name": "Liberian Dollar", "symbol": "$" },
    "timezones": [
      { "zoneName": "Africa/Monrovia", "gmtOffset": "UTC+00:00" }
    ]
  },
  {
    "countryCode": "LY",
    "phoneCode": "+218",
    "countryName": "Libya",
    "flag": "🇱🇾",
    "flagImg": "https://flagcdn.com/ly.svg",
    "currency": { "code": "LYD", "name": "Libyan Dinar", "symbol": "ل.د" },
    "timezones": [
      { "zoneName": "Africa/Tripoli", "gmtOffset": "UTC+02:00" }
    ]
  },
  {
    "countryCode": "LI",
    "phoneCode": "+423",
    "countryName": "Liechtenstein",
    "flag": "🇱🇮",
    "flagImg": "https://flagcdn.com/li.svg",
    "currency": { "code": "CHF", "name": "Swiss Franc", "symbol": "Fr" },
    "timezones": [
      { "zoneName": "Europe/Vaduz", "gmtOffset": "UTC+01:00" }
    ]
  },
  {
    "countryCode": "LT",
    "phoneCode": "+370",
    "countryName": "Lithuania",
    "flag": "🇱🇹",
    "flagImg": "https://flagcdn.com/lt.svg",
    "currency": { "code": "EUR", "name": "Euro", "symbol": "€" },
    "timezones": [
      { "zoneName": "Europe/Vilnius", "gmtOffset": "UTC+02:00" }
    ]
  },
  {
    "countryCode": "LU",
    "phoneCode": "+352",
    "countryName": "Luxembourg",
    "flag": "🇱🇺",
    "flagImg": "https://flagcdn.com/lu.svg",
    "currency": { "code": "EUR", "name": "Euro", "symbol": "€" },
    "timezones": [
      { "zoneName": "Europe/Luxembourg", "gmtOffset": "UTC+01:00" }
    ]
  },
  {
    "countryCode": "MG",
    "phoneCode": "+261",
    "countryName": "Madagascar",
    "flag": "🇲🇬",
    "flagImg": "https://flagcdn.com/mg.svg",
    "currency": { "code": "MGA", "name": "Malagasy Ariary", "symbol": "Ar" },
    "timezones": [
      { "zoneName": "Indian/Antananarivo", "gmtOffset": "UTC+03:00" }
    ]
  },
  {
    "countryCode": "MW",
    "phoneCode": "+265",
    "countryName": "Malawi",
    "flag": "🇲🇼",
    "flagImg": "https://flagcdn.com/mw.svg",
    "currency": { "code": "MWK", "name": "Malawian Kwacha", "symbol": "MK" },
    "timezones": [
      { "zoneName": "Africa/Blantyre", "gmtOffset": "UTC+02:00" }
    ]
  },
  {
    "countryCode": "MY",
    "phoneCode": "+60",
    "countryName": "Malaysia",
    "flag": "🇲🇾",
    "flagImg": "https://flagcdn.com/my.svg",
    "currency": { "code": "MYR", "name": "Malaysian Ringgit", "symbol": "RM" },
    "timezones": [
      { "zoneName": "Asia/Kuala_Lumpur", "gmtOffset": "UTC+08:00" },
      { "zoneName": "Asia/Kuching", "gmtOffset": "UTC+08:00" }
    ]
  },
  {
    "countryCode": "MV",
    "phoneCode": "+960",
    "countryName": "Maldives",
    "flag": "🇲🇻",
    "flagImg": "https://flagcdn.com/mv.svg",
    "currency": { "code": "MVR", "name": "Maldivian Rufiyaa", "symbol": "Rf" },
    "timezones": [
      { "zoneName": "Indian/Maldives", "gmtOffset": "UTC+05:00" }
    ]
  },
  {
    "countryCode": "ML",
    "phoneCode": "+223",
    "countryName": "Mali",
    "flag": "🇲🇱",
    "flagImg": "https://flagcdn.com/ml.svg",
    "currency": { "code": "XOF", "name": "West African CFA Franc", "symbol": "Fr" },
    "timezones": [
      { "zoneName": "Africa/Bamako", "gmtOffset": "UTC+00:00" }
    ]
  },
  {
    "countryCode": "MT",
    "phoneCode": "+356",
    "countryName": "Malta",
    "flag": "🇲🇹",
    "flagImg": "https://flagcdn.com/mt.svg",
    "currency": { "code": "EUR", "name": "Euro", "symbol": "€" },
    "timezones": [
      { "zoneName": "Europe/Malta", "gmtOffset": "UTC+01:00" }
    ]
  },
  {
    "countryCode": "MH",
    "phoneCode": "+692",
    "countryName": "Marshall Islands",
    "flag": "🇲🇭",
    "flagImg": "https://flagcdn.com/mh.svg",
    "currency": { "code": "USD", "name": "United States Dollar", "symbol": "$" },
    "timezones": [
      { "zoneName": "Pacific/Majuro", "gmtOffset": "UTC+12:00" },
      { "zoneName": "Pacific/Kwajalein", "gmtOffset": "UTC+12:00" }
    ]
  },
  {
    "countryCode": "MR",
    "phoneCode": "+222",
    "countryName": "Mauritania",
    "flag": "🇲🇷",
    "flagImg": "https://flagcdn.com/mr.svg",
    "currency": { "code": "MRU", "name": "Mauritanian Ouguiya", "symbol": "UM" },
    "timezones": [
      { "zoneName": "Africa/Nouakchott", "gmtOffset": "UTC+00:00" }
    ]
  },
  {
    "countryCode": "MU",
    "phoneCode": "+230",
    "countryName": "Mauritius",
    "flag": "🇲🇺",
    "flagImg": "https://flagcdn.com/mu.svg",
    "currency": { "code": "MUR", "name": "Mauritian Rupee", "symbol": "₨" },
    "timezones": [
      { "zoneName": "Indian/Mauritius", "gmtOffset": "UTC+04:00" }
    ]
  },
  {
    "countryCode": "MX",
    "phoneCode": "+52",
    "countryName": "Mexico",
    "flag": "🇲🇽",
    "flagImg": "https://flagcdn.com/mx.svg",
    "currency": { "code": "MXN", "name": "Mexican Peso", "symbol": "$" },
    "timezones": [
      { "zoneName": "America/Mexico_City", "gmtOffset": "UTC-06:00" },
      { "zoneName": "America/Cancun", "gmtOffset": "UTC-05:00" },
      { "zoneName": "America/Merida", "gmtOffset": "UTC-06:00" },
      { "zoneName": "America/Monterrey", "gmtOffset": "UTC-06:00" },
      { "zoneName": "America/Matamoros", "gmtOffset": "UTC-06:00" },
      { "zoneName": "America/Mazatlan", "gmtOffset": "UTC-07:00" },
      { "zoneName": "America/Chihuahua", "gmtOffset": "UTC-07:00" },
      { "zoneName": "America/Ojinaga", "gmtOffset": "UTC-07:00" },
      { "zoneName": "America/Hermosillo", "gmtOffset": "UTC-07:00" },
      { "zoneName": "America/Tijuana", "gmtOffset": "UTC-08:00" }
    ]
  },
  {
    "countryCode": "FM",
    "phoneCode": "+691",
    "countryName": "Micronesia, Federated States of",
    "flag": "🇫🇲",
    "flagImg": "https://flagcdn.com/fm.svg",
    "currency": { "code": "USD", "name": "United States Dollar", "symbol": "$" },
    "timezones": [
      { "zoneName": "Pacific/Pohnpei", "gmtOffset": "UTC+11:00" },
      { "zoneName": "Pacific/Chuuk", "gmtOffset": "UTC+10:00" }
    ]
  },
  {
    "countryCode": "MD",
    "phoneCode": "+373",
    "countryName": "Moldova",
    "flag": "🇲🇩",
    "flagImg": "https://flagcdn.com/md.svg",
    "currency": { "code": "MDL", "name": "Moldovan Leu", "symbol": "L" },
    "timezones": [
      { "zoneName": "Europe/Chisinau", "gmtOffset": "UTC+02:00" }
    ]
  },
  {
    "countryCode": "MC",
    "phoneCode": "+377",
    "countryName": "Monaco",
    "flag": "🇲🇨",
    "flagImg": "https://flagcdn.com/mc.svg",
    "currency": { "code": "EUR", "name": "Euro", "symbol": "€" },
    "timezones": [
      { "zoneName": "Europe/Monaco", "gmtOffset": "UTC+01:00" }
    ]
  },
  {
    "countryCode": "MN",
    "phoneCode": "+976",
    "countryName": "Mongolia",
    "flag": "🇲🇳",
    "flagImg": "https://flagcdn.com/mn.svg",
    "currency": { "code": "MNT", "name": "Mongolian Tögrög", "symbol": "₮" },
    "timezones": [
      { "zoneName": "Asia/Ulaanbaatar", "gmtOffset": "UTC+08:00" },
      { "zoneName": "Asia/Hovd", "gmtOffset": "UTC+07:00" },
      { "zoneName": "Asia/Choibalsan", "gmtOffset": "UTC+08:00" }
    ]
  },
  {
    "countryCode": "ME",
    "phoneCode": "+382",
    "countryName": "Montenegro",
    "flag": "🇲🇪",
    "flagImg": "https://flagcdn.com/me.svg",
    "currency": { "code": "EUR", "name": "Euro", "symbol": "€" },
    "timezones": [
      { "zoneName": "Europe/Podgorica", "gmtOffset": "UTC+01:00" }
    ]
  },
  {
    "countryCode": "MA",
    "phoneCode": "+212",
    "countryName": "Morocco",
    "flag": "🇲🇦",
    "flagImg": "https://flagcdn.com/ma.svg",
    "currency": { "code": "MAD", "name": "Moroccan Dirham", "symbol": "د.م." },
    "timezones": [
      { "zoneName": "Africa/Casablanca", "gmtOffset": "UTC+01:00" }
    ]
  },
  {
    "countryCode": "MZ",
    "phoneCode": "+258",
    "countryName": "Mozambique",
    "flag": "🇲🇿",
    "flagImg": "https://flagcdn.com/mz.svg",
    "currency": { "code": "MZN", "name": "Mozambican Metical", "symbol": "MT" },
    "timezones": [
      { "zoneName": "Africa/Maputo", "gmtOffset": "UTC+02:00" }
    ]
  },
  {
    "countryCode": "MM",
    "phoneCode": "+95",
    "countryName": "Myanmar",
    "flag": "🇲🇲",
    "flagImg": "https://flagcdn.com/mm.svg",
    "currency": { "code": "MMK", "name": "Myanmar Kyat", "symbol": "Ks" },
    "timezones": [
      { "zoneName": "Asia/Yangon", "gmtOffset": "UTC+06:30" }
    ]
  },
  {
    "countryCode": "NA",
    "phoneCode": "+264",
    "countryName": "Namibia",
    "flag": "🇳🇦",
    "flagImg": "https://flagcdn.com/na.svg",
    "currency": { "code": "NAD", "name": "Namibian Dollar", "symbol": "$" },
    "timezones": [
      { "zoneName": "Africa/Windhoek", "gmtOffset": "UTC+02:00" }
    ]
  },
  {
    "countryCode": "NR",
    "phoneCode": "+674",
    "countryName": "Nauru",
    "flag": "🇳🇷",
    "flagImg": "https://flagcdn.com/nr.svg",
    "currency": { "code": "AUD", "name": "Australian Dollar", "symbol": "$" },
    "timezones": [
      { "zoneName": "Pacific/Nauru", "gmtOffset": "UTC+12:00" }
    ]
  },
  {
    "countryCode": "NP",
    "phoneCode": "+977",
    "countryName": "Nepal",
    "flag": "🇳🇵",
    "flagImg": "https://flagcdn.com/np.svg",
    "currency": { "code": "NPR", "name": "Nepalese Rupee", "symbol": "₨" },
    "timezones": [
      { "zoneName": "Asia/Kathmandu", "gmtOffset": "UTC+05:45" }
    ]
  },
  {
    "countryCode": "NL",
    "phoneCode": "+31",
    "countryName": "Netherlands",
    "flag": "🇳🇱",
    "flagImg": "https://flagcdn.com/nl.svg",
    "currency": { "code": "EUR", "name": "Euro", "symbol": "€" },
    "timezones": [
      { "zoneName": "Europe/Amsterdam", "gmtOffset": "UTC+01:00" }
    ]
  },
  {
    "countryCode": "NZ",
    "phoneCode": "+64",
    "countryName": "New Zealand",
    "flag": "🇳🇿",
    "flagImg": "https://flagcdn.com/nz.svg",
    "currency": { "code": "NZD", "name": "New Zealand Dollar", "symbol": "$" },
    "timezones": [
      { "zoneName": "Pacific/Auckland", "gmtOffset": "UTC+12:00" },
      { "zoneName": "Pacific/Chatham", "gmtOffset": "UTC+12:45" }
    ]
  },
  {
    "countryCode": "NI",
    "phoneCode": "+505",
    "countryName": "Nicaragua",
    "flag": "🇳🇮",
    "flagImg": "https://flagcdn.com/ni.svg",
    "currency": { "code": "NIO", "name": "Nicaraguan Córdoba", "symbol": "C$" },
    "timezones": [
      { "zoneName": "America/Managua", "gmtOffset": "UTC-06:00" }
    ]
  },
  {
    "countryCode": "NE",
    "phoneCode": "+227",
    "countryName": "Niger",
    "flag": "🇳🇪",
    "flagImg": "https://flagcdn.com/ne.svg",
    "currency": { "code": "XOF", "name": "West African CFA Franc", "symbol": "Fr" },
    "timezones": [
      { "zoneName": "Africa/Niamey", "gmtOffset": "UTC+01:00" }
    ]
  },
  {
    "countryCode": "NG",
    "phoneCode": "+234",
    "countryName": "Nigeria",
    "flag": "🇳🇬",
    "flagImg": "https://flagcdn.com/ng.svg",
    "currency": { "code": "NGN", "name": "Nigerian Naira", "symbol": "₦" },
    "timezones": [
      { "zoneName": "Africa/Lagos", "gmtOffset": "UTC+01:00" }
    ]
  },
  {
    "countryCode": "MK",
    "phoneCode": "+389",
    "countryName": "North Macedonia",
    "flag": "🇲🇰",
    "flagImg": "https://flagcdn.com/mk.svg",
    "currency": { "code": "MKD", "name": "Macedonian Denar", "symbol": "ден" },
    "timezones": [
      { "zoneName": "Europe/Skopje", "gmtOffset": "UTC+01:00" }
    ]
  },
  {
    "countryCode": "NO",
    "phoneCode": "+47",
    "countryName": "Norway",
    "flag": "🇳🇴",
    "flagImg": "https://flagcdn.com/no.svg",
    "currency": { "code": "NOK", "name": "Norwegian Krone", "symbol": "kr" },
    "timezones": [
      { "zoneName": "Europe/Oslo", "gmtOffset": "UTC+01:00" }
    ]
  },
  {
    "countryCode": "OM",
    "phoneCode": "+968",
    "countryName": "Oman",
    "flag": "🇴🇲",
    "flagImg": "https://flagcdn.com/om.svg",
    "currency": { "code": "OMR", "name": "Omani Rial", "symbol": "ر.ع." },
    "timezones": [
      { "zoneName": "Asia/Muscat", "gmtOffset": "UTC+04:00" }
    ]
  },
  {
    "countryCode": "PK",
    "phoneCode": "+92",
    "countryName": "Pakistan",
    "flag": "🇵🇱",
    "flagImg": "https://flagcdn.com/pk.svg",
    "currency": { "code": "PKR", "name": "Pakistani Rupee", "symbol": "₨" },
    "timezones": [
      { "zoneName": "Asia/Karachi", "gmtOffset": "UTC+05:00" }
    ]
  },
  {
    "countryCode": "PW",
    "phoneCode": "+680",
    "countryName": "Palau",
    "flag": "🇵🇼",
    "flagImg": "https://flagcdn.com/pw.svg",
    "currency": { "code": "USD", "name": "United States Dollar", "symbol": "$" },
    "timezones": [
      { "zoneName": "Pacific/Palau", "gmtOffset": "UTC+09:00" }
    ]
  },
  {
    "countryCode": "PS",
    "phoneCode": "+970",
    "countryName": "Palestine",
    "flag": "🇵🇸",
    "flagImg": "https://flagcdn.com/ps.svg",
    "currency": { "code": "ILS", "name": "Israeli New Shekel", "symbol": "₪" },
    "timezones": [
      { "zoneName": "Asia/Gaza", "gmtOffset": "UTC+02:00" },
      { "zoneName": "Asia/Hebron", "gmtOffset": "UTC+02:00" }
    ]
  },
  {
    "countryCode": "PA",
    "phoneCode": "+507",
    "countryName": "Panama",
    "flag": "🇵🇦",
    "flagImg": "https://flagcdn.com/pa.svg",
    "currency": { "code": "PAB", "name": "Panamanian Balboa", "symbol": "B/." },
    "timezones": [
      { "zoneName": "America/Panama", "gmtOffset": "UTC-05:00" }
    ]
  },
  {
    "countryCode": "PG",
    "phoneCode": "+675",
    "countryName": "Papua New Guinea",
    "flag": "🇵🇬",
    "flagImg": "https://flagcdn.com/pg.svg",
    "currency": { "code": "PGK", "name": "Papua New Guinean Kina", "symbol": "K" },
    "timezones": [
      { "zoneName": "Pacific/Port_Moresby", "gmtOffset": "UTC+10:00" },
      { "zoneName": "Pacific/Bougainville", "gmtOffset": "UTC+11:00" }
    ]
  },
  {
    "countryCode": "PY",
    "phoneCode": "+595",
    "countryName": "Paraguay",
    "flag": "🇵🇾",
    "flagImg": "https://flagcdn.com/py.svg",
    "currency": { "code": "PYG", "name": "Paraguayan Guaraní", "symbol": "₲" },
    "timezones": [
      { "zoneName": "America/Asuncion", "gmtOffset": "UTC-04:00" }
    ]
  },
  {
    "countryCode": "PE",
    "phoneCode": "+51",
    "countryName": "Peru",
    "flag": "🇵🇪",
    "flagImg": "https://flagcdn.com/pe.svg",
    "currency": { "code": "PEN", "name": "Peruvian Sol", "symbol": "S/." },
    "timezones": [
      { "zoneName": "America/Lima", "gmtOffset": "UTC-05:00" }
    ]
  },
  {
    "countryCode": "PH",
    "phoneCode": "+63",
    "countryName": "Philippines",
    "flag": "🇵🇭",
    "flagImg": "https://flagcdn.com/ph.svg",
    "currency": { "code": "PHP", "name": "Philippine Peso", "symbol": "₱" },
    "timezones": [
      { "zoneName": "Asia/Manila", "gmtOffset": "UTC+08:00" }
    ]
  },
  {
    "countryCode": "PL",
    "phoneCode": "+48",
    "countryName": "Poland",
    "flag": "🇵🇱",
    "flagImg": "https://flagcdn.com/pl.svg",
    "currency": { "code": "PLN", "name": "Polish Złoty", "symbol": "zł" },
    "timezones": [
      { "zoneName": "Europe/Warsaw", "gmtOffset": "UTC+01:00" }
    ]
  },
  {
    "countryCode": "PT",
    "phoneCode": "+351",
    "countryName": "Portugal",
    "flag": "🇵🇹",
    "flagImg": "https://flagcdn.com/pt.svg",
    "currency": { "code": "EUR", "name": "Euro", "symbol": "€" },
    "timezones": [
      { "zoneName": "Europe/Lisbon", "gmtOffset": "UTC+00:00" },
      { "zoneName": "Atlantic/Madeira", "gmtOffset": "UTC+00:00" },
      { "zoneName": "Atlantic/Azores", "gmtOffset": "UTC-01:00" }
    ]
  },
  {
    "countryCode": "QA",
    "phoneCode": "+974",
    "countryName": "Qatar",
    "flag": "🇶🇦",
    "flagImg": "https://flagcdn.com/qa.svg",
    "currency": { "code": "QAR", "name": "Qatari Riyal", "symbol": "ر.ق" },
    "timezones": [
      { "zoneName": "Asia/Qatar", "gmtOffset": "UTC+03:00" }
    ]
  },
  {
    "countryCode": "RO",
    "phoneCode": "+40",
    "countryName": "Romania",
    "flag": "🇷🇴",
    "flagImg": "https://flagcdn.com/ro.svg",
    "currency": { "code": "RON", "name": "Romanian Leu", "symbol": "lei" },
    "timezones": [
      { "zoneName": "Europe/Bucharest", "gmtOffset": "UTC+02:00" }
    ]
  },
  {
    "countryCode": "RU",
    "phoneCode": "+7",
    "countryName": "Russia",
    "flag": "🇷🇺",
    "flagImg": "https://flagcdn.com/ru.svg",
    "currency": { "code": "RUB", "name": "Russian Ruble", "symbol": "₽" },
    "timezones": [
      { "zoneName": "Europe/Kaliningrad", "gmtOffset": "UTC+02:00" },
      { "zoneName": "Europe/Moscow", "gmtOffset": "UTC+03:00" },
      { "zoneName": "Europe/Samara", "gmtOffset": "UTC+04:00" },
      { "zoneName": "Asia/Yekaterinburg", "gmtOffset": "UTC+05:00" },
      { "zoneName": "Asia/Omsk", "gmtOffset": "UTC+06:00" },
      { "zoneName": "Asia/Krasnoyarsk", "gmtOffset": "UTC+07:00" },
      { "zoneName": "Asia/Irkutsk", "gmtOffset": "UTC+08:00" },
      { "zoneName": "Asia/Yakutsk", "gmtOffset": "UTC+09:00" },
      { "zoneName": "Asia/Vladivostok", "gmtOffset": "UTC+10:00" },
      { "zoneName": "Asia/Magadan", "gmtOffset": "UTC+11:00" },
      { "zoneName": "Asia/Kamchatka", "gmtOffset": "UTC+12:00" }
    ]
  },
  {
    "countryCode": "RW",
    "phoneCode": "+250",
    "countryName": "Rwanda",
    "flag": "🇷🇼",
    "flagImg": "https://flagcdn.com/rw.svg",
    "currency": { "code": "RWF", "name": "Rwandan Franc", "symbol": "Fr" },
    "timezones": [
      { "zoneName": "Africa/Kigali", "gmtOffset": "UTC+02:00" }
    ]
  },
  {
    "countryCode": "KN",
    "phoneCode": "+1-869",
    "countryName": "Saint Kitts and Nevis",
    "flag": "🇰🇳",
    "flagImg": "https://flagcdn.com/kn.svg",
    "currency": { "code": "XCD", "name": "East Caribbean Dollar", "symbol": "$" },
    "timezones": [
      { "zoneName": "America/St_Kitts", "gmtOffset": "UTC-04:00" }
    ]
  },
  {
    "countryCode": "LC",
    "phoneCode": "+1-758",
    "countryName": "Saint Lucia",
    "flag": "🇱🇨",
    "flagImg": "https://flagcdn.com/lc.svg",
    "currency": { "code": "XCD", "name": "East Caribbean Dollar", "symbol": "$" },
    "timezones": [
      { "zoneName": "America/St_Lucia", "gmtOffset": "UTC-04:00" }
    ]
  },
  {
    "countryCode": "VC",
    "phoneCode": "+1-784",
    "countryName": "Saint Vincent and the Grenadines",
    "flag": "🇻🇨",
    "flagImg": "https://flagcdn.com/vc.svg",
    "currency": { "code": "XCD", "name": "East Caribbean Dollar", "symbol": "$" },
    "timezones": [
      { "zoneName": "America/St_Vincent", "gmtOffset": "UTC-04:00" }
    ]
  },
  {
    "countryCode": "WS",
    "phoneCode": "+685",
    "countryName": "Samoa",
    "flag": "🇼🇸",
    "flagImg": "https://flagcdn.com/ws.svg",
    "currency": { "code": "WST", "name": "Samoan Tālā", "symbol": "T" },
    "timezones": [
      { "zoneName": "Pacific/Apia", "gmtOffset": "UTC+13:00" }
    ]
  },
  {
    "countryCode": "SM",
    "phoneCode": "+378",
    "countryName": "San Marino",
    "flag": "🇸🇲",
    "flagImg": "https://flagcdn.com/sm.svg",
    "currency": { "code": "EUR", "name": "Euro", "symbol": "€" },
    "timezones": [
      { "zoneName": "Europe/San_Marino", "gmtOffset": "UTC+01:00" }
    ]
  },
  {
    "countryCode": "ST",
    "phoneCode": "+239",
    "countryName": "Sao Tome and Principe",
    "flag": "🇸🇹",
    "flagImg": "https://flagcdn.com/st.svg",
    "currency": { "code": "STN", "name": "São Tomé and Príncipe Dobra", "symbol": "Db" },
    "timezones": [
      { "zoneName": "Africa/Sao_Tome", "gmtOffset": "UTC+00:00" }
    ]
  },
  {
    "countryCode": "SA",
    "phoneCode": "+966",
    "countryName": "Saudi Arabia",
    "flag": "🇸🇦",
    "flagImg": "https://flagcdn.com/sa.svg",
    "currency": { "code": "SAR", "name": "Saudi Riyal", "symbol": "ر.س" },
    "timezones": [
      { "zoneName": "Asia/Riyadh", "gmtOffset": "UTC+03:00" }
    ]
  },
  {
    "countryCode": "SN",
    "phoneCode": "+221",
    "countryName": "Senegal",
    "flag": "🇸🇳",
    "flagImg": "https://flagcdn.com/sn.svg",
    "currency": { "code": "XOF", "name": "West African CFA Franc", "symbol": "Fr" },
    "timezones": [
      { "zoneName": "Africa/Dakar", "gmtOffset": "UTC+00:00" }
    ]
  },
  {
    "countryCode": "RS",
    "phoneCode": "+381",
    "countryName": "Serbia",
    "flag": "🇷🇸",
    "flagImg": "https://flagcdn.com/rs.svg",
    "currency": { "code": "RSD", "name": "Serbian Dinar", "symbol": "дин" },
    "timezones": [
      { "zoneName": "Europe/Belgrade", "gmtOffset": "UTC+01:00" }
    ]
  },
  {
    "countryCode": "SC",
    "phoneCode": "+248",
    "countryName": "Seychelles",
    "flag": "🇸🇨",
    "flagImg": "https://flagcdn.com/sc.svg",
    "currency": { "code": "SCR", "name": "Seychellois Rupee", "symbol": "₨" },
    "timezones": [
      { "zoneName": "Indian/Mahe", "gmtOffset": "UTC+04:00" }
    ]
  },
  {
    "countryCode": "SL",
    "phoneCode": "+232",
    "countryName": "Sierra Leone",
    "flag": "🇸🇱",
    "flagImg": "https://flagcdn.com/sl.svg",
    "currency": { "code": "SLL", "name": "Sierra Leonean Leone", "symbol": "Le" },
    "timezones": [
      { "zoneName": "Africa/Freetown", "gmtOffset": "UTC+00:00" }
    ]
  },
  {
    "countryCode": "SG",
    "phoneCode": "+65",
    "countryName": "Singapore",
    "flag": "🇸🇬",
    "flagImg": "https://flagcdn.com/sg.svg",
    "currency": { "code": "SGD", "name": "Singapore Dollar", "symbol": "$" },
    "timezones": [
      { "zoneName": "Asia/Singapore", "gmtOffset": "UTC+08:00" }
    ]
  },
  {
    "countryCode": "SK",
    "phoneCode": "+421",
    "countryName": "Slovakia",
    "flag": "🇸🇰",
    "flagImg": "https://flagcdn.com/sk.svg",
    "currency": { "code": "EUR", "name": "Euro", "symbol": "€" },
    "timezones": [
      { "zoneName": "Europe/Bratislava", "gmtOffset": "UTC+01:00" }
    ]
  },
  {
    "countryCode": "SI",
    "phoneCode": "+386",
    "countryName": "Slovenia",
    "flag": "🇸🇮",
    "flagImg": "https://flagcdn.com/si.svg",
    "currency": { "code": "EUR", "name": "Euro", "symbol": "€" },
    "timezones": [
      { "zoneName": "Europe/Ljubljana", "gmtOffset": "UTC+01:00" }
    ]
  },
  {
    "countryCode": "SB",
    "phoneCode": "+677",
    "countryName": "Solomon Islands",
    "flag": "🇸🇧",
    "flagImg": "https://flagcdn.com/sb.svg",
    "currency": { "code": "SBD", "name": "Solomon Islands Dollar", "symbol": "$" },
    "timezones": [
      { "zoneName": "Pacific/Guadalcanal", "gmtOffset": "UTC+11:00" }
    ]
  },
  {
    "countryCode": "SO",
    "phoneCode": "+252",
    "countryName": "Somalia",
    "flag": "🇸🇴",
    "flagImg": "https://flagcdn.com/so.svg",
    "currency": { "code": "SOS", "name": "Somali Shilling", "symbol": "Sh" },
    "timezones": [
      { "zoneName": "Africa/Mogadishu", "gmtOffset": "UTC+03:00" }
    ]
  },
  {
    "countryCode": "ZA",
    "phoneCode": "+27",
    "countryName": "South Africa",
    "flag": "🇿🇦",
    "flagImg": "https://flagcdn.com/za.svg",
    "currency": { "code": "ZAR", "name": "South African Rand", "symbol": "R" },
    "timezones": [
      { "zoneName": "Africa/Johannesburg", "gmtOffset": "UTC+02:00" }
    ]
  },
  {
    "countryCode": "SS",
    "phoneCode": "+211",
    "countryName": "South Sudan",
    "flag": "🇸🇸",
    "flagImg": "https://flagcdn.com/ss.svg",
    "currency": { "code": "SSP", "name": "South Sudanese Pound", "symbol": "£" },
    "timezones": [
      { "zoneName": "Africa/Juba", "gmtOffset": "UTC+02:00" }
    ]
  },
  {
    "countryCode": "ES",
    "phoneCode": "+34",
    "countryName": "Spain",
    "flag": "🇪🇸",
    "flagImg": "https://flagcdn.com/es.svg",
    "currency": { "code": "EUR", "name": "Euro", "symbol": "€" },
    "timezones": [
      { "zoneName": "Europe/Madrid", "gmtOffset": "UTC+01:00" },
      { "zoneName": "Atlantic/Canary", "gmtOffset": "UTC+00:00" },
      { "zoneName": "Africa/Ceuta", "gmtOffset": "UTC+01:00" }
    ]
  },
  {
    "countryCode": "LK",
    "phoneCode": "+94",
    "countryName": "Sri Lanka",
    "flag": "🇱🇰",
    "flagImg": "https://flagcdn.com/lk.svg",
    "currency": { "code": "LKR", "name": "Sri Lankan Rupee", "symbol": "Rs" },
    "timezones": [
      { "zoneName": "Asia/Colombo", "gmtOffset": "UTC+05:30" }
    ]
  },
  {
    "countryCode": "SD",
    "phoneCode": "+249",
    "countryName": "Sudan",
    "flag": "🇸🇩",
    "flagImg": "https://flagcdn.com/sd.svg",
    "currency": { "code": "SDG", "name": "Sudanese Pound", "symbol": "ج.س." },
    "timezones": [
      { "zoneName": "Africa/Khartoum", "gmtOffset": "UTC+02:00" }
    ]
  },
  {
    "countryCode": "SR",
    "phoneCode": "+597",
    "countryName": "Suriname",
    "flag": "🇸🇷",
    "flagImg": "https://flagcdn.com/sr.svg",
    "currency": { "code": "SRD", "name": "Surinamese Dollar", "symbol": "$" },
    "timezones": [
      { "zoneName": "America/Paramaribo", "gmtOffset": "UTC-03:00" }
    ]
  },
  {
    "countryCode": "SE",
    "phoneCode": "+46",
    "countryName": "Sweden",
    "flag": "🇸🇪",
    "flagImg": "https://flagcdn.com/se.svg",
    "currency": { "code": "SEK", "name": "Swedish Krona", "symbol": "kr" },
    "timezones": [
      { "zoneName": "Europe/Stockholm", "gmtOffset": "UTC+01:00" }
    ]
  },
  {
    "countryCode": "CH",
    "phoneCode": "+41",
    "countryName": "Switzerland",
    "flag": "🇨🇭",
    "flagImg": "https://flagcdn.com/ch.svg",
    "currency": { "code": "CHF", "name": "Swiss Franc", "symbol": "Fr" },
    "timezones": [
      { "zoneName": "Europe/Zurich", "gmtOffset": "UTC+01:00" }
    ]
  },
  {
    "countryCode": "SY",
    "phoneCode": "+963",
    "countryName": "Syria",
    "flag": "🇸🇾",
    "flagImg": "https://flagcdn.com/sy.svg",
    "currency": { "code": "SYP", "name": "Syrian Pound", "symbol": "£" },
    "timezones": [
      { "zoneName": "Asia/Damascus", "gmtOffset": "UTC+03:00" }
    ]
  },
  {
    "countryCode": "TW",
    "phoneCode": "+886",
    "countryName": "Taiwan",
    "flag": "🇹🇼",
    "flagImg": "https://flagcdn.com/tw.svg",
    "currency": { "code": "TWD", "name": "New Taiwan Dollar", "symbol": "NT$" },
    "timezones": [
      { "zoneName": "Asia/Taipei", "gmtOffset": "UTC+08:00" }
    ]
  },
  {
    "countryCode": "TJ",
    "phoneCode": "+992",
    "countryName": "Tajikistan",
    "flag": "🇹🇯",
    "flagImg": "https://flagcdn.com/tj.svg",
    "currency": { "code": "TJS", "name": "Tajikistani Somoni", "symbol": "SM" },
    "timezones": [
      { "zoneName": "Asia/Dushanbe", "gmtOffset": "UTC+05:00" }
    ]
  },
  {
    "countryCode": "TZ",
    "phoneCode": "+255",
    "countryName": "Tanzania",
    "flag": "🇹🇿",
    "flagImg": "https://flagcdn.com/tz.svg",
    "currency": { "code": "TZS", "name": "Tanzanian Shilling", "symbol": "Sh" },
    "timezones": [
      { "zoneName": "Africa/Dar_es_Salaam", "gmtOffset": "UTC+03:00" }
    ]
  },
  {
    "countryCode": "TH",
    "phoneCode": "+66",
    "countryName": "Thailand",
    "flag": "🇹🇭",
    "flagImg": "https://flagcdn.com/th.svg",
    "currency": { "code": "THB", "name": "Thai Baht", "symbol": "฿" },
    "timezones": [
      { "zoneName": "Asia/Bangkok", "gmtOffset": "UTC+07:00" }
    ]
  },
  {
    "countryCode": "TL",
    "phoneCode": "+670",
    "countryName": "Timor-Leste",
    "flag": "🇹🇱",
    "flagImg": "https://flagcdn.com/tl.svg",
    "currency": { "code": "USD", "name": "United States Dollar", "symbol": "$" },
    "timezones": [
      { "zoneName": "Asia/Dili", "gmtOffset": "UTC+09:00" }
    ]
  },
  {
    "countryCode": "TG",
    "phoneCode": "+228",
    "countryName": "Togo",
    "flag": "🇹🇬",
    "flagImg": "https://flagcdn.com/tg.svg",
    "currency": { "code": "XOF", "name": "West African CFA Franc", "symbol": "Fr" },
    "timezones": [
      { "zoneName": "Africa/Lome", "gmtOffset": "UTC+00:00" }
    ]
  },
  {
    "countryCode": "TO",
    "phoneCode": "+676",
    "countryName": "Tonga",
    "flag": "🇹🇴",
    "flagImg": "https://flagcdn.com/to.svg",
    "currency": { "code": "TOP", "name": "Tongan Paʻanga", "symbol": "T$" },
    "timezones": [
      { "zoneName": "Pacific/Tongatapu", "gmtOffset": "UTC+13:00" }
    ]
  },
  {
    "countryCode": "TT",
    "phoneCode": "+1-868",
    "countryName": "Trinidad and Tobago",
    "flag": "🇹🇹",
    "flagImg": "https://flagcdn.com/tt.svg",
    "currency": { "code": "TTD", "name": "Trinidad and Tobago Dollar", "symbol": "$" },
    "timezones": [
      { "zoneName": "America/Port_of_Spain", "gmtOffset": "UTC-04:00" }
    ]
  },
  {
    "countryCode": "TN",
    "phoneCode": "+216",
    "countryName": "Tunisia",
    "flag": "🇹🇳",
    "flagImg": "https://flagcdn.com/tn.svg",
    "currency": { "code": "TND", "name": "Tunisian Dinar", "symbol": "د.ت" },
    "timezones": [
      { "zoneName": "Africa/Tunis", "gmtOffset": "UTC+01:00" }
    ]
  },
  {
    "countryCode": "TR",
    "phoneCode": "+90",
    "countryName": "Turkey",
    "flag": "🇹🇷",
    "flagImg": "https://flagcdn.com/tr.svg",
    "currency": { "code": "TRY", "name": "Turkish Lira", "symbol": "₺" },
    "timezones": [
      { "zoneName": "Europe/Istanbul", "gmtOffset": "UTC+03:00" }
    ]
  },
  {
    "countryCode": "TM",
    "phoneCode": "+993",
    "countryName": "Turkmenistan",
    "flag": "🇹🇲",
    "flagImg": "https://flagcdn.com/tm.svg",
    "currency": { "code": "TMT", "name": "Turkmenistan Manat", "symbol": "m" },
    "timezones": [
      { "zoneName": "Asia/Ashgabat", "gmtOffset": "UTC+05:00" }
    ]
  },
  {
    "countryCode": "TV",
    "phoneCode": "+688",
    "countryName": "Tuvalu",
    "flag": "🇹🇻",
    "flagImg": "https://flagcdn.com/tv.svg",
    "currency": { "code": "AUD", "name": "Australian Dollar", "symbol": "$" },
    "timezones": [
      { "zoneName": "Pacific/Funafuti", "gmtOffset": "UTC+12:00" }
    ]
  },
  {
    "countryCode": "UG",
    "phoneCode": "+256",
    "countryName": "Uganda",
    "flag": "🇺🇬",
    "flagImg": "https://flagcdn.com/ug.svg",
    "currency": { "code": "UGX", "name": "Ugandan Shilling", "symbol": "USh" },
    "timezones": [
      { "zoneName": "Africa/Kampala", "gmtOffset": "UTC+03:00" }
    ]
  },
  {
    "countryCode": "UA",
    "phoneCode": "+380",
    "countryName": "Ukraine",
    "flag": "🇺🇦",
    "flagImg": "https://flagcdn.com/ua.svg",
    "currency": { "code": "UAH", "name": "Ukrainian Hryvnia", "symbol": "₴" },
    "timezones": [
      { "zoneName": "Europe/Kyiv", "gmtOffset": "UTC+02:00" }
    ]
  },
  {
    "countryCode": "AE",
    "phoneCode": "+971",
    "countryName": "United Arab Emirates",
    "flag": "🇦🇪",
    "flagImg": "https://flagcdn.com/ae.svg",
    "currency": { "code": "AED", "name": "United Arab Emirates Dirham", "symbol": "د.إ" },
    "timezones": [
      { "zoneName": "Asia/Dubai", "gmtOffset": "UTC+04:00" }
    ]
  },
  {
    "countryCode": "GB",
    "phoneCode": "+44",
    "countryName": "United Kingdom",
    "flag": "🇬🇧",
    "flagImg": "https://flagcdn.com/gb.svg",
    "currency": { "code": "GBP", "name": "British Pound Sterling", "symbol": "£" },
    "timezones": [
      { "zoneName": "Europe/London", "gmtOffset": "UTC+00:00" }
    ]
  },
  {
    "countryCode": "US",
    "phoneCode": "+1",
    "countryName": "United States",
    "flag": "🇺🇸",
    "flagImg": "https://flagcdn.com/us.svg",
    "currency": { "code": "USD", "name": "United States Dollar", "symbol": "$" },
    "timezones": [
      { "zoneName": "America/New_York", "gmtOffset": "UTC-05:00" },
      { "zoneName": "America/Chicago", "gmtOffset": "UTC-06:00" },
      { "zoneName": "America/Denver", "gmtOffset": "UTC-07:00" },
      { "zoneName": "America/Los_Angeles", "gmtOffset": "UTC-08:00" },
      { "zoneName": "America/Phoenix", "gmtOffset": "UTC-07:00" },
      { "zoneName": "America/Anchorage", "gmtOffset": "UTC-09:00" },
      { "zoneName": "Pacific/Honolulu", "gmtOffset": "UTC-10:00" }
    ]
  },
  {
    "countryCode": "UY",
    "phoneCode": "+598",
    "countryName": "Uruguay",
    "flag": "🇺🇾",
    "flagImg": "https://flagcdn.com/uy.svg",
    "currency": { "code": "UYU", "name": "Uruguayan Peso", "symbol": "$" },
    "timezones": [
      { "zoneName": "America/Montevideo", "gmtOffset": "UTC-03:00" }
    ]
  },
  {
    "countryCode": "UZ",
    "phoneCode": "+998",
    "countryName": "Uzbekistan",
    "flag": "🇺🇿",
    "flagImg": "https://flagcdn.com/uz.svg",
    "currency": { "code": "UZS", "name": "Uzbekistani Soʻm", "symbol": "soʻm" },
    "timezones": [
      { "zoneName": "Asia/Tashkent", "gmtOffset": "UTC+05:00" }
    ]
  },
  {
    "countryCode": "VU",
    "phoneCode": "+678",
    "countryName": "Vanuatu",
    "flag": "🇻🇺",
    "flagImg": "https://flagcdn.com/vu.svg",
    "currency": { "code": "VUV", "name": "Vanuatu Vatu", "symbol": "Vt" },
    "timezones": [
      { "zoneName": "Pacific/Efate", "gmtOffset": "UTC+11:00" }
    ]
  },
  {
    "countryCode": "VE",
    "phoneCode": "+58",
    "countryName": "Venezuela",
    "flag": "🇻🇪",
    "flagImg": "https://flagcdn.com/ve.svg",
    "currency": { "code": "VES", "name": "Venezuelan Bolívar", "symbol": "Bs." },
    "timezones": [
      { "zoneName": "America/Caracas", "gmtOffset": "UTC-04:00" }
    ]
  },
  {
    "countryCode": "VN",
    "phoneCode": "+84",
    "countryName": "Vietnam",
    "flag": "🇻🇳",
    "flagImg": "https://flagcdn.com/vn.svg",
    "currency": { "code": "VND", "name": "Vietnamese Đồng", "symbol": "₫" },
    "timezones": [
      { "zoneName": "Asia/Ho_Chi_Minh", "gmtOffset": "UTC+07:00" }
    ]
  },
  {
    "countryCode": "YE",
    "phoneCode": "+967",
    "countryName": "Yemen",
    "flag": "🇾🇪",
    "flagImg": "https://flagcdn.com/ye.svg",
    "currency": { "code": "YER", "name": "Yemeni Rial", "symbol": "﷼" },
    "timezones": [
      { "zoneName": "Asia/Aden", "gmtOffset": "UTC+03:00" }
    ]
  },
  {
    "countryCode": "ZM",
    "phoneCode": "+260",
    "countryName": "Zambia",
    "flag": "🇿🇲",
    "flagImg": "https://flagcdn.com/zm.svg",
    "currency": { "code": "ZMW", "name": "Zambian Kwacha", "symbol": "ZK" },
    "timezones": [
      { "zoneName": "Africa/Lusaka", "gmtOffset": "UTC+02:00" }
    ]
  },
  {
    "countryCode": "ZW",
    "phoneCode": "+263",
    "countryName": "Zimbabwe",
    "flag": "🇿🇼",
    "flagImg": "https://flagcdn.com/zw.svg",
    "currency": { "code": "ZWL", "name": "Zimbabwean Dollar", "symbol": "$" },
    "timezones": [
      { "zoneName": "Africa/Harare", "gmtOffset": "UTC+02:00" }
    ]
  }
]